<form [formGroup]="inputForm">
  <form-row>
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Hinweis</mat-label>
      <input matInput type="text" maxlength="40" formControlName="shortDescription" />
    </mat-form-field>
  </form-row>

  <form-row>
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Langer Hinweis</mat-label>
      <textarea matInput type="text" rows="5" formControlName="longDescription"></textarea>
    </mat-form-field>
  </form-row>

  <form-row
    *ngIf="(showAssignedTransformerStation$ | async) && inputForm.contains('assignedTransformerStation')">
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Zugeordnete Station</mat-label>
      <input matInput type="text" maxlength="255" formControlName="assignedTransformerStation" />
    </mat-form-field>
  </form-row>

  <form-row *ngIf="showExternalIdField$ | async">
    <mat-form-field fxFlex="90" appearance="outline">
      <mat-label>Externe ID</mat-label>
      <input matInput type="text" [formControlName]="'externalId'" />
    </mat-form-field>
  </form-row>
  <form-row *ngIf="(showExternalCustomerIdField$ | async) && inputForm.contains('externalCustomerId')">
    <mat-form-field fxFlex="90" appearance="outline">
      <mat-label>Externe Kunden-ID</mat-label>
      <input matInput type="text" [formControlName]="'externalCustomerId'" />
    </mat-form-field>
  </form-row>

  <!--<div fxLayout="row" fxFlexAlign="stretch" *ngIf="config.showGridConnectionPointId">
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Netzverknüpfungspunkt Id:</mat-label>
      <input matInput type="text" maxlength="150" formControlName="gridConnectionPointId" />
    </mat-form-field>
  </div>
  <div fxLayout="row" fxFlexAlign="stretch" *ngIf="config.showGridConnectionPointId">
    <button
      mat-stroked-button
      color="primary"
      (click)="copyIdFromConnectionObject()"
      style="margin-left: 1em">
      <mat-icon style="margin-right: 0.25em">content_copy</mat-icon>
      Id aus Anschlussobjekt übernehmen
    </button>
  </div>-->

  <form-row *ngIf="inputForm.get('externalGridRegistrationId')">
    <mat-form-field appearance="outline" fxFlex="90">
      <mat-label>Externe Id Netzanmeldung</mat-label>
      <input matInput type="text" maxlength="255" formControlName="externalGridRegistrationId" />
    </mat-form-field>
  </form-row>
</form>
